import { z } from 'zod';
import { apiClient } from '@api/client';
import { localeSchema, type Locale } from './schema';

const responseSchema = z.object({
  statusCode: z.number(),
  message: z.string(),
  data: z.array(localeSchema).nullable(),
  error: z.string().nullable().optional(),
});

export async function listLocales(
  opts: { activeOnly?: boolean } = {},
): Promise<Locale[]> {
  const response = await apiClient.get('/locales', {
    params: { activeOnly: opts.activeOnly ?? true },
  });
  const parsed = responseSchema.safeParse(response.data);
  if (!parsed.success) {
    throw new Error(`Invalid locales response: ${parsed.error.message}`);
  }
  return parsed.data.data ?? [];
}
